"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$keys2 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = withEntity;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _uuid = _interopRequireDefault(require("../../utils/uuid"));

var _entityNormalizer = require("@rexlabs/entity-normalizer");

var _lodash = _interopRequireDefault(require("lodash"));

var _react2 = require("../../utils/react");

var _coreDecorators = require("core-decorators");

var _env = require("../../utils/env");

var _map = require("./map");

var _queries = require("../../utils/queries");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys2(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context7; _forEachInstanceProperty2(_context7 = ownKeys(Object(source), true)).call(_context7, function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context8; _forEachInstanceProperty2(_context8 = ownKeys(Object(source))).call(_context8, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * HoC that loads a specific entity item either from the store or from the API
 * @param  {Object} model
 * @param  {string|Function} id
 * @param  {string} namespace
 * @return {Function}
 */
function withEntity(model, id) {
  var options = (arguments.length <= 2 ? undefined : arguments[2]) === undefined ? {} : arguments.length <= 2 ? undefined : arguments[2];

  if ((arguments.length <= 2 ? 0 : arguments.length - 2) > 1 || !_lodash.default.isObject(options)) {
    if (_env.__DEV__) {
      console.warn('Not using an object as argument for `withEntity` is deprecated and might not be supported in future versions!');
    }

    options = {
      namespace: arguments.length <= 2 ? undefined : arguments[2],
      args: arguments.length <= 3 ? undefined : arguments[3],
      autoload: arguments.length <= 4 ? undefined : arguments[4],
      fields: arguments.length <= 5 ? undefined : arguments[5]
    };
  }

  var _options = options,
      namespace = _options.namespace,
      _options$args = _options.args,
      args = _options$args === void 0 ? {} : _options$args,
      _options$autoload = _options.autoload,
      autoload = _options$autoload === void 0 ? true : _options$autoload,
      fields = _options.fields;
  return function (WrappedComponent) {
    var _class, _class2, _temp;

    var componentName = (0, _react2.getDisplayName)(WrappedComponent);
    var NAME = namespace || model.modelName;

    var WithEntity = (0, _coreDecorators.autobind)(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
      (0, _inherits2.default)(WithEntity, _Component);

      var _super = _createSuper(WithEntity);

      function WithEntity(props) {
        var _context;

        var _this;

        (0, _classCallCheck2.default)(this, WithEntity);
        _this = _super.call(this, props);
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "memPrepProps", _lodash.default.memoize(_this.prepProps));
        _this.id = _lodash.default.isFunction(id) ? id(props) : id;
        _this.autoloaded = false;
        _this.statusPromises = {};
        _this.consumerId = (0, _concat.default)(_context = "".concat(componentName, "--")).call(_context, (0, _uuid.default)());
        return _this;
      }

      (0, _createClass2.default)(WithEntity, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.loadDataOrRegister();
          this.autoloaded = autoload;
        } // eslint-disable-next-line babel/camelcase

      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
          var oldStatus = _lodash.default.get(this.props, '__state.item.status');

          var newStatus = _lodash.default.get(nextProps, '__state.item.status');

          if (oldStatus !== newStatus && this.statusPromises[newStatus]) {
            var _context2;

            (0, _forEach.default)(_context2 = this.statusPromises[newStatus]).call(_context2, function (promise) {
              promise.resolve();
            });
            delete this.statusPromises[newStatus];
          }

          if (!autoload) {
            return;
          }

          var newId = _lodash.default.isFunction(id) ? id(nextProps) : id;
          var oldId = this.id;

          if (newId !== oldId) {
            this.id = newId;
            this.loadDataOrRegister(nextProps);
          } // Keep old args around for comparison


          var oldArgs = this.argsOverwrite;
          this.argsOverwrite = this.getArgs(args, nextProps);

          if (!_lodash.default.isEqual(oldArgs, this.argsOverwrite)) {
            // Refetch entity if arguments changed
            this.loadDataOrRegister(nextProps);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.props.__actions.unregisterConsumer({
            uuid: this.consumerId
          });
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
          if (_lodash.default.isFunction(id)) {
            if (id(this.props) !== id(nextProps)) {
              return true;
            }
          }

          if (_lodash.default.isFunction(args)) {
            if (args(this.props) !== args(nextProps)) {
              return true;
            }
          } // Custom shallow equal here!


          for (var key in nextProps) {
            var _context3;

            if (!(0, _includes.default)(_context3 = ['__state', '__actions']).call(_context3, key) && this.props[key] !== nextProps[key]) {
              return true;
            }
          }

          return this.props.__state.item !== nextProps.__state.item;
        }
      }, {
        key: "loadDataOrRegister",
        value: function loadDataOrRegister() {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

          if (!autoload) {
            // Don't do anything id autoload is disabled
            return;
          }

          this.id = _lodash.default.isFunction(id) ? id(props) : id;

          if (!this.id) {
            // Don't do anything if no id is defined
            return;
          }

          var forceLoad = true;
          this.argsOverwrite = this.getArgs(args, props);

          var item = _lodash.default.get(props, '__state.item');

          if (item) {
            var _context4, _context5;

            var argsChanged = false;

            for (var key in item.args) {
              if (key === 'include') {
                continue;
              }

              var oldArg = item.args[key];
              var newArg = this.argsOverwrite[key];

              if (oldArg !== newArg) {
                argsChanged = true;
              }
            }

            if ((0, _includes.default)(_context4 = [_entityNormalizer.STATUS_LOADING]).call(_context4, item.status)) {
              // Don't trigger another API call if item is already loading
              // => NOTE: this might lead to conflicts if the second component
              // requests more data than the first one :(
              forceLoad = false;
            } else if ( // If status is `loaded` and either no fields are defined or defined
            // fields are already available, don't re-fetch!
            (0, _includes.default)(_context5 = [_entityNormalizer.STATUS_LOADED]).call(_context5, item.status) && !argsChanged && (!fields || (0, _queries.containsAllFields)(item.data, fields))) {
              forceLoad = false;
            }
          }

          if (forceLoad) {
            this.props.__actions.fetchItem({
              id: this.id,
              uuid: this.consumerId,
              args: this.argsOverwrite
            }).catch(function (e) {
              if (_env.__DEV__) {
                console.error('Caught error in `withEntity` initial load!');
                console.error(e);
              }
            });
          } else {
            this.props.__actions.registerConsumer({
              id: this.id,
              uuid: this.consumerId,
              related: item.related
            });
          }
        }
      }, {
        key: "waitForStatus",
        value: function waitForStatus(status) {
          var _this2 = this;

          return new _promise.default(function (resolve, reject) {
            if (_lodash.default.get(_this2.props, '__state.item.status') === status) {
              resolve();
            } else {
              if (!_this2.statusPromises[status]) {
                _this2.statusPromises[status] = [];
              }

              _this2.statusPromises[status].push({
                resolve: resolve,
                reject: reject
              });
            }
          });
        }
      }, {
        key: "getStatus",
        value: function getStatus(props) {
          var status = _lodash.default.get(props, '__state.item.status');

          if (!status) {
            status = autoload ? _entityNormalizer.STATUS_LOADING : _entityNormalizer.STATUS_IDLE;
          } else {
            var actualData = _lodash.default.get(props, '__state.item.data');

            if (fields && autoload && !this.autoloaded && !(0, _queries.containsAllFields)(actualData, fields)) {
              status = _entityNormalizer.STATUS_FETCHING;
            }
          }

          return status;
        }
      }, {
        key: "getArgs",
        value: function getArgs(args, props) {
          var _this3 = this;

          if (_lodash.default.isFunction(args)) {
            return args(props);
          }

          if (_lodash.default.isObject(args)) {
            var _context6;

            return (0, _reduce.default)(_context6 = (0, _keys.default)(args)).call(_context6, function (all, key) {
              all[key] = _this3.getArgs(args[key], props);
              return all;
            }, {});
          }

          return args;
        }
      }, {
        key: "getData",
        value: function getData(props) {
          var data = _lodash.default.get(props, '__state.item.data', {});

          return fields ? (0, _queries.filterDataToFields)(data, fields) : data;
        } // TODO: right now below we are applying reasonable defaults to the entity actions
        //  manually. Would be good if we could pull that out to where the actions get created
        //  to use meta data when available instead

      }, {
        key: "prepProps",
        value: function prepProps(props) {
          var _this4 = this;

          var coreProps = _objectSpread({}, props);

          delete coreProps.__state;
          delete coreProps.__actions;
          return _objectSpread(_objectSpread({}, coreProps), {}, (0, _defineProperty2.default)({}, NAME, _objectSpread(_objectSpread(_objectSpread({}, props.__state), props.__actions), {}, {
            consumerUuid: this.consumerId,
            waitForStatus: this.waitForStatus,
            item: _objectSpread(_objectSpread({}, _lodash.default.get(props, '__state.item', {})), {}, {
              // If fields are specified, only return requested fields!
              data: this.getData(props),
              // Ensure status is never undefined
              //  This will happen when connecting to an entity ... the state will be undefined
              //  until `componentDidMount` triggers the loading action...
              status: this.getStatus(props)
            })
          }, this.id ? {
            fetchItem: function fetchItem() {
              var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return props.__actions.fetchItem(_objectSpread(_objectSpread({
                id: _this4.id,
                uuid: _this4.consumerId
              }, args), {}, {
                data: _objectSpread(_objectSpread({}, _this4.argsOverwrite), args.data || {})
              }));
            },
            refresh: function refresh() {
              var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return props.__actions.refreshItem(_objectSpread(_objectSpread({
                id: _this4.id,
                uuid: _lodash.default.get(props, '__state.item.consumers', [_this4.consumerId])
              }, args), {}, {
                data: _objectSpread(_objectSpread({}, _this4.argsOverwrite), args.data || {})
              }));
            },
            updateItem: function updateItem() {
              var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return props.__actions.updateItem(_objectSpread(_objectSpread({
                id: _this4.id,
                uuid: _this4.consumerId
              }, args), {}, {
                data: _objectSpread(_objectSpread({}, _this4.argsOverwrite), args.data || {})
              }));
            },
            trashItem: function trashItem() {
              var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return props.__actions.trashItem(_objectSpread(_objectSpread({
                id: _this4.id,
                uuid: _this4.consumerId
              }, args), {}, {
                data: _objectSpread(_objectSpread({}, _this4.argsOverwrite), args.data || {})
              }));
            }
          } : {})));
        } // Memoize prepProps, cause it will create new props reference
        // every time otherwise!

      }, {
        key: "render",
        value: function render() {
          var prepProps = this.memPrepProps(this.props);
          return /*#__PURE__*/_react.default.createElement(WrappedComponent, prepProps);
        }
      }]);
      return WithEntity;
    }(_react.Component), (0, _defineProperty2.default)(_class2, "displayName", "withEntity(".concat(componentName, ")")), _temp)) || _class;

    var mapStateToProps = function mapStateToProps(state, props) {
      var itemId = _lodash.default.isFunction(id) ? id(props) : id;
      return {
        __state: (0, _map.mapEntityState)(model, itemId, state, props, fields)
      };
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      return {
        __actions: (0, _map.mapEntityDispatch)(model, dispatch)
      };
    };

    return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WithEntity);
  };
}